module.exports = new __parcel__URL__("list-merge-modal-single-project-light.604d6477.gif").toString();